import { buildAttachmentAwareRequest } from 'repositories/utils/attachmentRequest'

import { berthApiClient } from '../berthApiClient'

import { updateBookingEndpoint } from './endpoint'
import type { UpdateBookingParams, UpdateBookingResponse } from './type'

export const updateBooking = async (
  params: UpdateBookingParams
): Promise<UpdateBookingResponse> => {
  const { body, config } = buildAttachmentAwareRequest(params)
  const res = await berthApiClient.put<UpdateBookingResponse>(updateBookingEndpoint, body, config)
  return res.data
}
